import { apiClient, omrehBaseClient } from "./client";

const GetAll = () => {
  return omrehBaseClient
    .get("/Broker");
}

const GetByKey = (id) => {
  return omrehBaseClient
    .get("/Broker/GetById", {
      params: {
        'key': id
      }
    });
}

const GetByBrokerCode = (brokerCode) => {
  return omrehBaseClient
    .get("/Broker/GetByBrokerCode", {
      params: {
        'brokerCode': brokerCode
      }
    });
}

const BrokerDropDown = () => {
  return omrehBaseClient
    .get("/Broker/BrokerDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/Broker/GetForUser");
}
const SoftDelete = (id) => {
  return apiClient
    .delete("/Broker/SoftDelete", {
      params: {
        'Id': id
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Broker', {
    'name': data.name,
    'code': data.code,
    'numberOfGroups': data.numberOfGroups,
    'provinceId': data.provinceId
  }
  )
}
const Update = (id, data) => {
  return apiClient.put('/Broker', {
    'id': id,
    'name': data.name,
    'code': data.code,
    'numberOfGroups': data.numberOfGroups,
    'provinceId': data.provinceId,
    'isActive': data.isActive
  }
  )
}
const brokerApi = {
  Add, Update, GetAll, GetByKey, BrokerDropDown, GetForUser, SoftDelete, GetByBrokerCode
}

export default brokerApi